import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SalesPeriodDashboardContainerProps } from "../../../../interfaces/containers";
import SalesPeriod from "../../../../pages/Profile/Dashboard/SalesPeriod";
import { getSalesPeriod, cleanSalesPeriod } from "../../../../actions/dashboard";

function mapStateToProps(state: SalesPeriodDashboardContainerProps) {
    return {
        user: state.auth.user,
        branch: state.profile.dashboard.branch,
        salesPeriod: state.profile.dashboard.salesPeriod,
        date: state.profile.dashboard.date
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getSalesPeriod,
        cleanSalesPeriod
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesPeriod);